import { Fragment } from 'react'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../../../Table'

import { renderListingProfileApplicantsCell } from './ListingProfileApplicantsRow.utils'

import * as styles from './ListingProfileApplicantsRow.module.css'

function ListingProfileApplicantsRow({
  actionLeft,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  index,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
  ...restProps
}) {
  const { handleCallAction, handleClick, handleMouseEnter, handleMouseLeave } =
    useTableRowActions({ item, ...restProps })

  const className = useTableRowModClassName({
    className: styles.ListingProfileApplicantsRow,
    isActive: focusedRow === item.id,
  })

  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderListingProfileApplicantsCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            name: column.name,
            showCellBorder,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default ListingProfileApplicantsRow
